const skillDataSet = [
  {
    title: 'Javascript',
    desc: '主要以 Angular 和 Vue3 開發金融業內部系統；Side project 以 React18 為主。',
    contents: ['Angular', 'Vue', 'React', 'Next.js', 'TypeScript', 'jQuery'],
  },
  {
    title: 'CSS',
    desc: '擅長使用 Tailwind 和 Bootstrap 快速客製具有 RWD 的使用者介面。',
    contents: ['Tailwind', 'Bootstrap', 'Sass', 'Responsive Web'],
  },
  {
    title: 'Backend',
    desc: '主要以 Java Spring Boot 開發金融業內部系統；Side project 以 Express.js 為主。',
    contents: ['Java', 'Spring Boot', 'Node.js', 'Express.js', 'PHP', 'Laravel'],
  },
  {
    title: 'Data Visualization',
    desc: '學生時期常使用各種資料視覺工具打造 dahsboard。',
    contents: ['Google Charts', 'D3.js', 'Ploty.js', 'Highcharts.js'],
  },
  {
    title: 'Design',
    desc: '學生時期常製作社團文宣。',
    contents: ['illustrator', 'PhotoImpact'],
  },
  {
    title: 'Video',
    desc: '學生時期常剪輯遊戲影片。',
    contents: ['Sony Vegas'],
  },
];

export default skillDataSet;
